// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1adci","requiredAsterisk":"Info_requiredAsterisk__2HsLw"};